import { useNavigate, useSearch } from '@tanstack/react-router';
import { useEffect, useMemo } from 'react';
import { useObjectScope } from '@/shared/object-scope';

export function useDynamicPricingPropertyScope(): string | undefined {
  const navigate = useNavigate();
  const search = useSearch({ strict: false }) as { apartment?: unknown };
  const { groups, groupId, isLoading, isError, isOffline } = useObjectScope();
  // Ohne Objektliste ist ein Apartment nicht ungültig, sondern unbekannt – der Link bleibt stehen.
  const unknown = isLoading || ((isError || isOffline) && groups.length === 0);
  const requestedId = typeof search.apartment === 'string' ? search.apartment : undefined;
  const allowedIds = useMemo(() => {
    const scopedGroups = groupId ? groups.filter((group) => group.id === groupId) : groups;
    return new Set(
      scopedGroups.flatMap((group) => group.apartments.map((apartment) => apartment.id)),
    );
  }, [groupId, groups]);
  const validId = !unknown && requestedId && allowedIds.has(requestedId) ? requestedId : undefined;

  useEffect(() => {
    if (!unknown && requestedId && !validId) {
      void navigate({ to: '/dynamic-pricing/configuration', search: {}, replace: true });
    }
  }, [unknown, navigate, requestedId, validId]);

  return validId;
}
